import React,{useState,useRef,useEffect} from 'react'
import DatePicker from 'react-date-picker';
import ReactToPrint from 'react-to-print';
import {ComponentToPrint} from './Print';
import ReactToExcel from 'react-html-table-to-excel';
import axios from 'axios';
function RConsumoExcessivo() {
    const [step,setStep]=useState({iva:"",m3:"",valg:"",tsc:"",mpag:""});
  const [value, SonChange] = useState(new Date());
  const [fvalue, fSonChange] = useState(new Date());
  const printChart = useRef(null);
  const [compras,setCompras]=useState(null);
  const [tipoc,setTipoCl]=useState('');
  const Send=()=>{

}


useEffect(()=>{
    axios({
        method:"post",
        url:`${localStorage.getItem('url')}/web/TodasCompras/`,
        headers:{'Authorization':`token ${localStorage.getItem('token')}`,'Content-Type':'application/json' },
        data:{id:"sds"}
    }).then(dat=>{ if(dat.status!==200){
        throw Error('Dados de acesso invalidos');  
            }
        return dat
     } ).then( df=>{
            console.log(df.data)
            setCompras(df.data);
       
      }
   
       ).catch(e=>{
    })
    
},[])
const Search_tipo_limete=(row)=>{
    return row.filter((row)=>
    row.mes.toLowerCase().indexOf(tipoc)>-1)
}


  return (
    <div>
        <h5>Relatorio Estatistico > Consumo Excessivo</h5>
        <div className='nopias'>
         <div className='Filtrar_i'>
               <div className='NP'>
                {/*Provincia*/}
               <div>
               Provincia
               <select id="combo" onChange={(e)=>{
                         const provincia=e.target.value;
                         step.mpag=provincia;
                         }}>
                          
                          <option value="NUM">---</option>
                           
                            <option value="maputo">Maputo</option>
                            <option value="nampula">Nampula</option>
                                       </select>

               </div>
                {/*Cidade*/}
                <div>
                Cidade
                <select id="combo" onChange={(e)=>{
                         const provincia=e.target.value;
                         step.mpag=provincia;
                         }}>
                           
                           <option value="NUM">---</option>
                           
                            <option value="nampula">Nampula</option>
                            <option value="maputo">Maputo </option>
                            <option value="matola">Matola</option>
                          
                                       </select>
                </div>
                 {/*Bairro */}
                 <div>
                  Bairro
                  <select id="combo" onChange={(e)=>{
                         const provincia=e.target.value;
                         step.mpag=provincia;
                         }}>
                          
                          <option value="NUM">---</option>
                           
                            <option value="ubc">Urbano Central</option>
              
                                       </select>
                 </div>
                {/*Vila*/}

                <div>
                  Vila <select id="combo" onChange={(e)=>{
                         const provincia=e.target.value;
                         step.mpag=provincia;
                         }}>
                            <option value="NUM">---</option>
                           
                            <option value="NUM">Bombeiros</option>
                            <option value="MPESA">25 de Setembro</option>
                            <option value="MMOLA">1º de Maio</option>
                            <option value="MP24">Limoeiros</option>
                           
                                       </select>
                </div>
                <div>
                  Intervalo
                  <DatePicker className='datepicke' onChange={SonChange} value={value} />
                </div>
                  <div>
                    Fim
                  <DatePicker className='datepicke' onChange={fSonChange} value={fvalue}/>
                  </div>
               </div>

               <div className='NP'>
                {/*Provincia*/}
               <div>
                Empresa
               <select id="combo" onChange={(e)=>{
                         const provincia=e.target.value;
                         step.mpag=provincia;
                         }}>
                          
                          <option value="NUM">---</option>
                           
                            <option value="fpnampula">FIPAG-Nampula</option>
                                       </select>

               </div>
                {/*Cidade*/}
                <div>
                Agencia
                <select id="combo" onChange={(e)=>{
                         const provincia=e.target.value;
                         step.mpag=provincia;
                         }}>
                           
                           <option value="NUM">---</option>
                           
                            <option value="nampula">Cidade de Nampula</option>
                           
                                       </select>
                </div>
                 {/*Bairro */}
                 <div>
                  Tipo de Cliente
                  <select id="combo" onChange={(e)=>{
                         const provincia=e.target.value;
                         setTipoCl(provincia);
                         }}>
                          
                          <option value="NUM">---</option>
                           
                            <option value="domestico">Domestico</option>
                            <option value="industrial">Industrial</option>
                            <option value="publico">Publico</option>
                            <option value="fontenaria">Fontenaria</option>
                            <option value="comercial">Comercial</option>
              
                                       </select>
                 </div>
                {/*Vila*/}

                 </div>
          <>
          <div className='tabela_consumo'>
            <table id='tabela_consumos_i'>
            <thead>
      <tr>
        <th>Nome do Cliente</th>
        <th>Numero do Contador</th>
        <th>Numero da Compra</th>
        <th>Volume total em m3</th>
       
      </tr>
    </thead>
    {compras && <tbody>{Search_tipo_limete(compras).map((val,key)=>
            {
            return  <tr> 
            <td>{val.nomec}</td>
            <td>{val.nrcontador}</td>
            <td>MPS|{val.id}</td>
            <td>{val.metroscubicos}</td>
            
         
            </tr>
            
            }
            )}</tbody>}

            </table>
          </div>
          <> <img  id="imagem"src={require('./images/printer.png')}  />
          <ReactToPrint
          trigger={() => {
             return <a  href="#">   
             <button  id="opcao" value="Nao" onClick={Send} >Imprimir
             </button>
 </a>;
          }}
          content={() => printChart.current}
        />
          <img  id="imagem"src={require('./images/excel.png')}  />
          <ReactToExcel 
                    id='opcao'
                    table='tabela_consumos_i'
                    filename='Relatorios_de_consumo'
                    sheet='sheet 1'
                    buttonText='Exportar'/>
          </>
          <div>
          <ComponentToPrint ref={printChart}>
            <div className='Relatorio_para_Impressao'>
            <h5>Relatorio Estatistico Volume Consumido</h5>
            <label>Data de Impressao:</label>
            <div><label>Inicio:15/08/2022</label>
            <label>Fim:05/09/2022</label>
            </div>
            <div className='tabela_cnsumo'>
            <table id='tabela_consumos_i'>
            <thead>
      <tr>
        <th>Nome do Cliente</th>
        <th>Numero do Contador</th>
        <th>Numero da Compra</th>
        <th>Volume total em m3</th>
       
      </tr>
    </thead>
    {compras && <tbody>{Search_tipo_limete(compras).map((val,key)=>
            {
            return  <tr> 
            <td>{val.nomec}</td>
            <td>{val.nrcontador}</td>
            <td>MPS|{val.id}</td>
            <td>{val.metroscubicos}</td>
            
         
            </tr>
            
            }
            )}</tbody>}

            </table>
          </div>

            </div>
         </ComponentToPrint>
          
          </div>
          </>     

         </div>


          </div>
    </div>
  )
}

export default RConsumoExcessivo